module.exports = {
    path: ['/mobile/ishare/loc/usmidterm2026', '/mobile/news/loc/usmidterm2026'], // String类型 或 Array类型
    pxtorem: 75,     // Boolean类型 或 Number类型：是否需要px2rem，如果想关闭pxtorem，请把该参数删掉 或者 改为false
    cdncache: 120,   // Number类型：cdn缓存时间
    edit: false,     // Boolean类型：是否开启可视化
    ssr: false,      // Boolean类型：是否开启ssr
    online: true,    // Boolean类型：是否上线，仅生产环境有效
    uiImg: '',       // String / Array 类型： UI走查用的图片链接
    allData: {
        transferV3: [
            ["pageConfig:页面配置数据","KVProxy","getCustom","doc_857f3e76db3aa88ca9ccc1e40827ceb2",{"json":true}],
            ["house:众议院","KVProxy","getCustom","doc_c0052f4f14572665fb858d4d2482a6f1",{"json":true}],
            ["senate:参议院","KVProxy","getCustom","doc_4f6e07b5e1db1cd7a25b3aafa3e64def",{"json":true}],
            ["governor:州长","KVProxy","getCustom","doc_8c38d68010b3f66a85815354e3f7d036",{"json":true}],
            ["totals:汇总","KVProxy","getCustom","doc_dec56d8e3bbf4952f1aa422a91d66dbb",{"json":true}]
        ]
    },     // Object类型
    handler: false,   // Boolean类型，默认值：false，如果设置为true，需要自己实现allData获取逻辑 
    renderAfterOnload: false, // 在onload事件触发时，再加载 ssrhtml 和 业务脚本
    appPreload: false, // 提升当前页面在凤凰app中的打开速度（设置为true，就会在打开app时，进行css 和 js预加载）
    prefetch: [], // 提升同项目的其他页面的打开速度，如要预加载 mobile_details和mobile_history的css，js, 则配置prefetch: ['mobile_details', 'mobile_history']  即可
    tongji: true,   // Boolean类型：是否注入统计脚本，注入的碎片地址是：223152，如果设置为false，请自己实现所有统计逻辑
    gloableSettingsExt: { // 给 gloableSettings 添加额外的参数, $id$ 为占位符，自动生成，生成规则：`${命名空间}_${项目名}_${页面在src下的文件目录}`, 例如：custom_normal_pc_index 
        clientPageId: '$id$',
        sharePageId: '$id$',
    }
}
